
import { defineComponent, ref } from 'vue'
import { WeveButtonIcon } from '@weve/ui'

import {
  ArrowExpandLeftIcon,
  ArrowExpandRightIcon,
  MediaIcon,
  CogIcon,
  ListBoxIcon,
} from '@icons'
import { usePermissions } from '@/use'

import { SidebarEntity } from './Sidebar.types'
import ActivitySidebarSection from './ActivitySidebarSection.vue'
import ActivityGroupSidebarSection from './ActivityGroupSidebarSection.vue'
import RoomSidebarSection from './RoomSidebarSection.vue'
import SidebarSectionHeader from './SidebarSectionHeader.vue'

export default defineComponent({
  name: 'AppSidebar',
  components: {
    SidebarSectionHeader,
    WeveButtonIcon,
    ArrowExpandLeftIcon,
    ArrowExpandRightIcon,
    MediaIcon,
    CogIcon,
    ListBoxIcon,
    ActivitySidebarSection,
    ActivityGroupSidebarSection,
    RoomSidebarSection,
  },
  setup() {
    const { isAdmin } = usePermissions()
    const expanded = ref(true)
    const openSection = ref<SidebarEntity | undefined>(SidebarEntity.ROOM)

    function toggle() {
      expanded.value = !expanded.value
      if (!expanded.value) {
        openSection.value = undefined
      }
    }

    function toggleSection(entity: SidebarEntity) {
      if (entity === openSection.value) {
        openSection.value = undefined
        return
      }
      openSection.value = entity
    }

    function isSectionOpen(entity: SidebarEntity) {
      return openSection.value === entity
    }

    return {
      isAdmin,
      expanded,
      toggle,
      isSectionOpen,
      toggleSection,
      SidebarEntity,
    }
  },
})
